const DocumentType = {
    OTHER: 1,
    IMAGE: 2,
    PDF: 3
};

export default DocumentType;
